export default {
  resetState: ({ commit }) => commit('resetState'),
  login ({ dispatch, commit ,state}, credentials,deeplink) {
    commit('loading', true)
    dispatch('emit', {type: 'authentication', options: credentials}, {root: true} )
  },
  register ({ dispatch, commit }, data) {
    // commit('loginRequest', { credentials })
    data.register = true
    dispatch('emit', {type: 'authentication', options: data}, {root: true} )
  },
  authenticate ({ dispatch, commit, state }) {
    var token  = state.token
    //commit('resetState')
    //console.log('auth->authenticate')
    dispatch('emit', {type: 'authentication', options: {token: token}}, {root: true} )
  },
  authenticated ({ commit }, settings) {
    commit('loginSuccess', settings )
  },
  setSelect ({ dispatch, commit, state }, select){
    commit('setSelect', select )
    dispatch('emit', {type: 'settings.set', options: {select: state.settings.select}}, {root: true} )
  },
  setUser ({ dispatch, commit, state }, user){
    commit('setUser', user )
    dispatch('emit', {type: 'user.set', options: {user: state.settings._user}}, {root: true} )
  },
  setRelation ({ commit }, relation) {
    commit('setRelation', relation )
  },
  addToRelation ({ state, commit }, update) {
    commit('setRelation', Object.assign(state.relation, update) )
  },
  resetRelation({ commit }, relation) {
    commit('resetRelation', relation )
  },
  logout ({ dispatch, commit }) {
    dispatch('emit', {type: 'logout', options: {}}, {root: true} )
    dispatch('resetState', null, {root: true})
    commit('logout')
  },
  socket_connect ({ dispatch, commit, state }) {
    /*console.log('auth socket connect',state)
    if (state.authenticated) {
      console.log('reauthenticate',{token: state.token})
      dispatch('emit', {type: 'authentication', options: {token: state.token}}, {root: true} )
    }*/
  }
}